import _ from 'lodash';
import androidDevices from './android-devices';
import iosDevices from './ios-devices';

const DEVICE_MODEL_PATTERN = /(android|ios|windows)_(.*)_[a-z0-9]+$/;

export default class DeviceUtils {

  static findDeviceName = (id) => {
    // console.log('find device name with id: ', id);
    const match = DEVICE_MODEL_PATTERN.exec(id);
    // console.log('match: ', match);
    if (match) {
      const os = match[1];
      const model = match[2];
      // console.log('os: ', os, ', model: ', model);
      let devices = [];
      if (os === 'ios') {
        devices = iosDevices;
      } else if (os === 'android') {
        devices = androidDevices;
      }
      model = _.replace(model, '_', '-');
      const device = devices.find(item => item.model === model);
      // console.log('device: ', device);
      if (!_.isNil(device)) {
        const {manufacturer, codename, market_name} = device;
        let name = manufacturer;
        name = (_.isEmpty(name) ? '' : name + ' ') + market_name;
        if (_.isEmpty(name)) {
          name = codename;
        }
        return name;
      }
    }
    return id;
  };
}



// WEBPACK FOOTER //
// ./src/utils/DeviceUtils.js